import { defineMessages } from 'react-intl';

export const organizationApiKeysMessages = defineMessages({
  tab: {
    id: 'organizationApiKeys.tab',
    defaultMessage: 'API Keys',
  },
  title: {
    id: 'organizationApiKeys.title',
    defaultMessage: 'Create organization API key',
  },
  description: {
    id: 'organizationApiKeys.description',
    defaultMessage:
      'Generate a new API key for this organization. The secret is shown only once, right after creation — copy and store it securely.',
  },
  expiresAtLabel: {
    id: 'organizationApiKeys.expiresAt.label',
    defaultMessage: 'Expires at',
  },
  expiresAtPlaceholder: {
    id: 'organizationApiKeys.expiresAt.placeholder',
    defaultMessage: 'Select expiration date and time',
  },
  expiresAtRequired: {
    id: 'organizationApiKeys.expiresAt.required',
    defaultMessage: 'Expiration date is required',
  },
  expiresAtInPast: {
    id: 'organizationApiKeys.expiresAt.inPast',
    defaultMessage: 'Expiration date must be in the future',
  },
  commentLabel: {
    id: 'organizationApiKeys.comment.label',
    defaultMessage: 'Comment',
  },
  commentPlaceholder: {
    id: 'organizationApiKeys.comment.placeholder',
    defaultMessage: 'Optional note, e.g. what this key is for',
  },
  colComment: {
    id: 'organizationApiKeys.col.comment',
    defaultMessage: 'Comment',
  },
  via: {
    id: 'organizationApiKeys.via',
    defaultMessage: 'Created via',
  },
  viaClient: {
    id: 'organizationApiKeys.via.client',
    defaultMessage: 'Client',
  },
  viaPartnerApi: {
    id: 'organizationApiKeys.via.partnerApi',
    defaultMessage: 'Partner API',
  },
  viaMlPipelines: {
    id: 'organizationApiKeys.via.mlPipelines',
    defaultMessage: 'ML Pipelines',
  },
  submit: {
    id: 'organizationApiKeys.submit',
    defaultMessage: 'Create API key',
  },
  createSuccess: {
    id: 'organizationApiKeys.createSuccess',
    defaultMessage: 'API key created',
  },
  createError: {
    id: 'organizationApiKeys.createError',
    defaultMessage: 'Failed to create API key',
  },
  resultTitle: {
    id: 'organizationApiKeys.resultTitle',
    defaultMessage: 'API key created — copy the secret now',
  },
  resultWarning: {
    id: 'organizationApiKeys.resultWarning',
    defaultMessage:
      'This is the only time the secret will be shown. Once you leave this page it cannot be retrieved again.',
  },
  secretLabel: {
    id: 'organizationApiKeys.secret.label',
    defaultMessage: 'API key secret',
  },
  keyIdLabel: {
    id: 'organizationApiKeys.keyId.label',
    defaultMessage: 'Key ID',
  },
  copy: {
    id: 'organizationApiKeys.copy',
    defaultMessage: 'Copy',
  },
  copySuccess: {
    id: 'organizationApiKeys.copySuccess',
    defaultMessage: 'API key secret copied to clipboard',
  },
  copyError: {
    id: 'organizationApiKeys.copyError',
    defaultMessage: 'Failed to copy to clipboard',
  },
  createAnother: {
    id: 'organizationApiKeys.createAnother',
    defaultMessage: 'Create another key',
  },
  listTitle: {
    id: 'organizationApiKeys.listTitle',
    defaultMessage: 'Existing API keys',
  },
  listError: {
    id: 'organizationApiKeys.listError',
    defaultMessage: 'Failed to load API keys',
  },
  viewOnlyNote: {
    id: 'organizationApiKeys.viewOnlyNote',
    defaultMessage: 'You have read-only access. Creating and deleting keys requires the APIKey_CanEdit permission.',
  },
  colId: {
    id: 'organizationApiKeys.col.id',
    defaultMessage: 'Key ID',
  },
  colCreatedBy: {
    id: 'organizationApiKeys.col.createdBy',
    defaultMessage: 'Created by',
  },
  colCreatedAt: {
    id: 'organizationApiKeys.col.createdAt',
    defaultMessage: 'Created at',
  },
  colExpiresAt: {
    id: 'organizationApiKeys.col.expiresAt',
    defaultMessage: 'Expires at',
  },
  colStatus: {
    id: 'organizationApiKeys.col.status',
    defaultMessage: 'Status',
  },
  colActions: {
    id: 'organizationApiKeys.col.actions',
    defaultMessage: 'Actions',
  },
  statusActive: {
    id: 'organizationApiKeys.status.active',
    defaultMessage: 'Active',
  },
  statusExpired: {
    id: 'organizationApiKeys.status.expired',
    defaultMessage: 'Expired',
  },
  delete: {
    id: 'organizationApiKeys.delete',
    defaultMessage: 'Delete',
  },
  deleteConfirmTitle: {
    id: 'organizationApiKeys.deleteConfirmTitle',
    defaultMessage: 'Delete this API key?',
  },
  deleteConfirmContent: {
    id: 'organizationApiKeys.deleteConfirmContent',
    defaultMessage: 'Any integration using this key will immediately stop working. This cannot be undone.',
  },
  deleteSuccess: {
    id: 'organizationApiKeys.deleteSuccess',
    defaultMessage: 'API key deleted',
  },
  deleteError: {
    id: 'organizationApiKeys.deleteError',
    defaultMessage: 'Failed to delete API key',
  },
});
